const MOBILE_OR_TABLET_USER_AGENT =
  /Android|iPhone|iPad|iPod|IEMobile|Opera Mini|Mobile|Tablet|Silk|PlayBook/i;

export type MobilePreviewDeviceSignals = {
  forcePreview: boolean;
  maxTouchPoints: number;
  platform: string;
  userAgent: string;
};

export const shouldUseMobilePreview = ({
  forcePreview,
  maxTouchPoints,
  platform,
  userAgent,
}: MobilePreviewDeviceSignals) => {
  const isModernIPad = platform === "MacIntel" && maxTouchPoints > 1;

  return (
    forcePreview || isModernIPad || MOBILE_OR_TABLET_USER_AGENT.test(userAgent)
  );
};

export const shouldUseMobilePreviewInBrowser = () =>
  shouldUseMobilePreview({
    forcePreview:
      new URLSearchParams(window.location.search).get("mobilePreview") === "1",
    maxTouchPoints: navigator.maxTouchPoints || 0,
    platform: navigator.platform || "",
    userAgent: navigator.userAgent || "",
  });

export const getMobilePreviewUrl = (currentHref: string) =>
  new URL("mobile.html", currentHref).href;
